module.exports = require('./IconBooleanCell');
